module.exports = require('./IconBooleanCell');
